import { clsx } from 'clsx';
import type { ReactNode } from 'react';
import styles from './ui.module.css';

/**
 * Строка с цветным маркером.
 *
 * Маркер несёт смысл, а не украшает. Точка — состояние: под тумблером в
 * профиле бирюзовая значит «ссылки в реестре нет», малиновая — «она открыта
 * всем», текст в обоих случаях серый. Ромб — принадлежность к блоку: в
 * правилах им помечены пункты, и цвет у него тот же, что у контура карточки,
 * то есть запреты от порядка проверки отличаются с одного взгляда.
 */
export type BulletTone = 'cyan' | 'pink' | 'lilac';

const TONE: Record<BulletTone, string> = {
  cyan: styles.bulletCyan,
  pink: styles.bulletPink,
  lilac: styles.bulletLilac,
};

export function Bullet({
  tone,
  shape = 'dot',
  size = 'name',
  children,
}: {
  tone: BulletTone;
  shape?: 'dot' | 'diamond';
  /**
   * Кегль ПЕРВОЙ строки ряда — по нему знак и центруется. Без него ряд брал
   * кегль у платформы (16 px), знак вставал по чужой базовой линии, а сам
   * блок выходил выше своего текста. `name` — подпись карточки (правила),
   * `ui` — мелкое пояснение (профиль).
   */
  size?: 'name' | 'ui';
  children: ReactNode;
}) {
  return (
    <div className={clsx(styles.bullet, size === 'ui' && styles.bulletUi, TONE[tone])}>
      <span
        className={clsx(
          styles.bulletMark,
          shape === 'diamond' ? styles.bulletDiamond : styles.bulletDot,
        )}
      />
      <span className={styles.bulletText}>{children}</span>
    </div>
  );
}
